module.exports = __webpack_public_path__ + "img/WOLT_WM_TIPPSPIEL.c3c5c6e6.png";